module.exports = __webpack_public_path__ + "static/media/noticias_inversion_video_1.a88c3984.jpg";